import getBlockTemplates from './block-templates';

const getBlockTemplateById = (state, blockTemplateId) =>
  getBlockTemplates(state).find((blockTemplate) => blockTemplate.id === blockTemplateId) || null;

export default getBlockTemplateById;
